// Plain-English reasons for production lines Priority refused.
//
// The Edge Function (submit-production-report) already sends a short reason in
// `error` and Priority's raw text in `detail`. Until that version is deployed - and for
// reports saved before it - `error` holds the raw "502: {...}" text instead, so the same
// rules run here as a fallback. Keep LINE_ERROR_RULES in step with the Edge Function.

export const GENERIC_LINE_ERROR = 'Priority rejected this line';
export const NO_ANSWER_LINE_ERROR = 'No answer from Priority for this line - check Priority before retrying it';

const LINE_ERROR_RULES = [
  {
    test: (status, text) => /inventory balances are being calculated|recalculating inventory balances/i.test(text),
    message: 'Priority is recalculating inventory balances - try again in a few minutes'
  },
  {
    test: (status, text) => status === 401 || status === 403
      || /api cannot be run|permission|not authori[sz]ed|privilege|access denied/i.test(text),
    message: 'Priority refused access - ask an admin to check permissions'
  },
  {
    test: (status, text) => /\bclosed\b/i.test(text),
    message: 'This work order is closed in Priority'
  },
  {
    test: (status, text) => /(exceed|greater than|more than|larger than).{0,60}(balance|quantit|planned|remain)|(balance|quantit).{0,40}(exceed|insufficient)/i.test(text),
    message: 'Quantity is more than Priority allows for this work order'
  },
  {
    test: (status, text) => /component|kit\b|raw material|shortage|not enough|insufficient|negative (balance|inventory)/i.test(text),
    message: 'Not enough components in stock for this work order'
  },
  {
    test: (status, text) => /not approved|blocked|frozen|inactive|on hold|status (does not|doesn't) allow|cannot be (reported|revised)/i.test(text),
    message: 'The part or work order is blocked or not approved in Priority'
  },
  {
    // The request for this line threw (older Edge Function versions sent the exception text)
    test: (status, text) => !status && /fetch failed|network|timed? ?out|connection|aborted/i.test(text),
    message: NO_ANSWER_LINE_ERROR
  }
];

// Short reason for raw Priority text, optionally prefixed "NNN: " with the HTTP status
export const plainLineError = (raw) => {
  const text = String(raw || '');
  const status = Number((/^(\d{3}):/.exec(text) || [])[1]) || 0;
  return LINE_ERROR_RULES.find(rule => rule.test(status, text))?.message || GENERIC_LINE_ERROR;
};

const PLAIN_MESSAGES = new Set([GENERIC_LINE_ERROR, ...LINE_ERROR_RULES.map(rule => rule.message)]);

// { message, detail } for a failed line result. `detail` is null when there is nothing
// more technical to show than the message itself.
export const describeLineFailure = (line) => {
  if (line?.detail) return { message: line.error || GENERIC_LINE_ERROR, detail: line.detail };
  const raw = line?.error || '';
  if (PLAIN_MESSAGES.has(raw)) return { message: raw, detail: null };
  return { message: plainLineError(raw), detail: raw || null };
};
